import React, {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import Tooltip from '../../../CoreWrappers/Tooltip';
import StyledExportWithTopDetails from './StyledExportWithTopDetails';
import {generateExcelWithTopDetails} from './utils/generateExcelWithTopDetails';
import Button from '../../../CoreWrappers/Button';

const ExportWithTopDetails = ({
	getDataToExport,
	buttonTitle,
	labels,
	exportButtonLabel,
	requestData,
	dataReceived,
	generateTopDetails = null
}) => {
	const [isExporting, setIsExporting] = useState(false);

	const [userDateFormat, userTimezone] = useSelector(({userPreferences}) => [
		userPreferences.dateFormat,
		userPreferences.timeZoneISOCode
	]);

	useEffect(() => {
		if (isExporting && dataReceived) {
			const originalData = getDataToExport();
			generateExcelWithTopDetails(userDateFormat, userTimezone, labels, originalData, setIsExporting);
		}
	}, [dataReceived]);

	const exportData = () => {
		setIsExporting(true);
		//with following validation it is decided if use the RequestFlow (disptach call) or custom (it is sent as prop)
		requestData && requestData();
		generateTopDetails && generateTopDetails(userDateFormat, userTimezone, labels, getDataToExport(), setIsExporting);
	};

	const exportButtonTooltip = generateTopDetails !== null ? labels.exportButtonTooltip : buttonTitle;

	const exportButton = () => {
		const props = {
			variant: 'text-alt',
			size: 'small',
			className: 'export-variant',
			onClick: () => exportData(),
			label: exportButtonLabel ? exportButtonLabel : labels.exportData,
			disabled: isExporting
		};
		return <Button {...props} />;
	};

	const tooltipProps = {
		tooltipText: exportButtonTooltip,
		allowClick: true,
		trigger: exportButton()
	};
	return (
		<StyledExportWithTopDetails className="export-btn-wrap">
			<Tooltip {...tooltipProps} />
		</StyledExportWithTopDetails>
	);
};

export default ExportWithTopDetails;
